// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Copyright (c) 2026 Miskulin Technologies. All rights reserved.
// ================================================================
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './shared/Toast';
import './shared/modern-ux.css';

function App() {
  return (
<ToastProvider position="top-right">
<Routes>
      <Route path="/" element={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}><h1>Vantage Ops</h1></div>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    <Route path="/demo-management" element={<ProtectedRoute><DemoManagementPage /></ProtectedRoute>} />

    </Routes>
  </ToastProvider>
  );
}

export default App;
